import { RfpBidsSimpleWithoutIds } from '@gm2/common';

export class RfpBidsSimple extends RfpBidsSimpleWithoutIds {
    public _id: string;
    public serviceTypeId: string;
}
